import { useRef } from 'react';
import { useScrollState } from '@atlassian/jira-software-fast-virtual/src/services/use-scroll-state/index.tsx';
import { useBoardSelector } from '../../index.tsx';
import { isDragging as isDraggingSelector } from '../../selectors/board/board-selectors.tsx';
import { getIsCMPBoard } from '../../selectors/software/software-selectors.tsx';

/**
 * Virtualisation with absolute positioning requires extra style updates due to offset and height adjusting.
 * We want to avoid it in the initial load until the interaction starts, e.g. scrolling, dragging.
 */
export const useShouldBeAbsolutePositioned = () => {
	const { scrollTop } = useScrollState();
	const isDragging = useBoardSelector(isDraggingSelector);
	const hasInteracted = useRef(scrollTop > 0 || isDragging);
	const isCMPBoard = useBoardSelector(getIsCMPBoard);

	if (!isCMPBoard) {
		return true;
	}

	if (hasInteracted.current) {
		return true;
	}

	if (scrollTop > 0 || isDragging) {
		hasInteracted.current = true;
		return true;
	}

	return false;
};
